export const en = {
    "English": "English",
    "Spanish": "Spanish",
    "Translate": "Traducir",
    "Join account": "Join account",
    "Phone": "Phone",
    "You will receive an verification SMS code": "You will receive an verification SMS code",
    "Don't you have account?": "Don't you have account?",
    "Register for free": "Register for free",
    "Log in": "Log in",
    "Insurances": "Insurances",
    "Add polices": "Add polices",
    "Hire insurances": "Hire insurances",
    "Promotions": "Promotions",
    "Login": "Login",
    "Home": "Home",
    "My profile": "My profile",
    "Contact data": "Contact data",
    "Field is required": "Field is required",
    "Email": "Email",
    "Save": "Save",
    "Personal data": "Personal data",
    "Name": "Name",
    "First surname": "First surname",
    "Second surname": "Second surname",
    "DNI / NIE": "DNI / NIE",
    "Verification SMS": "Verification SMS",
    "Please, insert code we sent you by SMS to": "Please, insert code we sent you by SMS to",
    "Send again to": "Send again to",
    "Send code with a call": "Send code with a call",
    "is not my phone number": "is not my phone number",
    "SMS code": "SMS code",
    "Chat Bot": "Chat Bot",
    "Hello! looks like you want to hire an insurance. Complete information I will request you. Simply and fast!": "Hello! looks like you want to hire an insurance. Complete information I will request you. Simply and fast!",
    "First all I need...": "First all I need...",
    "Well done! Next information I would need is...": "Well done! Next information I would need is...",
    "Perfect! Keep going with": "Perfect! Keep going with",
    "This looks so good. Please fill next field too": "This looks so good. Please fill next field too",
    "Slowly and carefully...well done! Neeext!": "Slowly and carefully...well done! Neeext!",
    "You leave field empty. No problem, this is not mandatory. Keep going with": "You leave field empty. No problem, this is not mandatory. Keep going with",
    "Choose an option": "Choose an option",
    "This fill is required. You need to fill it": "This fill is required. You need to fill it",
    "The information you filled have a wrong format. Please change it": "The information you filled have a wrong format. Please change it",
    "Next information will be about": "Next information will be about",
    "First all I will need data from": "First all I will need data from",
    "Yes": "Yes",
    "No": "No",
    "I prefer not to answer": "I prefer not to answer",
    "Register": "Register",
    "Register free": "Register free",
    "Continue": "Continue",
    "Do you have an account already?": "Do you have an account already?",
    "Add policies": "Add policies",
    "Search your company": "Search your company",
    "Select companies which you have insurances hired": "Select companies which you have insurances hired",
    "Actual insurances": "Actual insurances",
    "Next": "Next",
    "Add policy": "Add policy",
    "Who or what you have insured?": "Who or what you have insured?",
    "Price": "Price",
    "to": "to",
    "ANNUAL": "ANNUAL",
    "HALF_YEARLY": "HALF_YEARLY",
    "FOUR_MONTHLY": "FOUR_MONTHLY",
    "QUARTERLY": "QUARTERLY",
    "BIMONTHLY": "BIMONTHLY",
    "MONTHLY": "MONTHLY",
    "FORTNIGHTLY": "FORTNIGHTLY",
    "WEEKLY": "WEEKLY",
    "UNIQUE": "UNIQUE",
    "Attach your contracts": "Attach your contracts",
    "Capture your contracts": "Capture your contracts",
    "Add the policy": "Add the policy",
    "Cancel": "Cancel",
    "You can upload multiple policies from one company clicking on \"Add policy\"": "You can upload multiple policies from one company clicking on \"Add policy\"",
    "Renovation date": "Renovation date",
    "Frequency": "Frequency",
    "Policy": "Policy",
    "Insurance type": "Insurance type",
    "Policies": "Policies",
    "Complete information": "Complete information",
    "Edit": "Edit",
    "Add existing": "Add existing",
    "Hire new": "Hire new",
    "You need to do some change to save": "You need to do some change to save",
    "Pay attention": "Pay attention",
    "422": "422",
    "500": "500",
    "401": "401",
    "My account": "My account",
    "Profile": "Profile",
    "Logout": "Logout",
    "What insurance do you want to hire?": "What insurance do you want to hire?",
    "Number need to have 9 digits and start with 6 or 7": "Number need to have 9 digits and start with 6 or 7",
    "Need to be 4 digits": "Need to be 4 digits",
    "Annual total": "Annual total",
    "My policies": "My policies",
    "My administred policies": "My administred policies",
    "Company logo": "Company logo",
    "Asesor image": "Asesor image",
    "Know more about me": "Know more about me",
    "Your advisor": "Your advisor",
    "Advisor": "Advisor",
    "Offers": "Offers",
    "Oh! You don't have active offers": "Oh! You don't have active offers",
    "Request a check for your fees from insurances page or find a new insurance for you": "Request a check for your fees from insurances page or find a new insurance for you",
    "Request new insurance": "Request new insurance",
    "Please, fill your data": "Please, fill your data",
    "Complete your profile": "Complete your profile",
    "Improve insurance": "Improve insurance",
    "Call assistance": "Call assistance",
    "See policy": "See policy",
    "Expiration date": "Expiration date",
    "Object or person secured": "Object or person secured",
    "Reference value": "Reference value",
    "Back": "Back",
    "Delete": "Delete",
    "Claim sinister": "Claim sinister",
    "seconds to send another SMS": "seconds to send another SMS",
    "You need to wait": "You need to wait",
    "Birth date": "Birth date",
    "Postal code": "Postal code",
    "Gender": "Gender",
    "Male": "Male",
    "Female": "Female",
    "My experience": "My experience",
    "My education": "My education",
    "About me": "About me",
    "No advisor": "No advisor",
    "Confirm": "Confirm",
    "Are you sure?": "Are you sure?",
    "You have insurances without policies. You will not save any policy from those companies": "You have insurances without policies. You will not save any policy from those companies",
    "Select items": "Select items",
    "Select": "Select",
    "Selected": "Selected",
    "My insurances": "My insurances",
    "Search municipality": "Search municipality",
    "Address": "Address",
    "Select your province": "Select your province",
    "Portal number": "Portal number",
    "Select your door": "Select your door",
    "Select your floor": "Select your floor",
    "Additional data": "Additional data",
    "Search address": "Search address",
    "Legal Advise": "Legal Advise",
    "Who are we?": "Who are we?",
    "Social Privacy Policy": "Social Privacy Policy",
    "Privacy Policy and Cookies": "Privacy Policy and Cookies",
    "Cookies Policy": "Cookies Policy",
    "Frequent Answers": "Frequent Answers",
    "Consent for Data Treatment": "Consent for Data Treatment",
    "I accept the": "I accept the",
    "and the": "and the",
    "from": "from",
    "Valid to": "Valid to",
    "Preparing your proposal": "Preparing your proposal",
    "New insurance": "New insurance",
    "BEST_PRICE": "BEST_PRICE",
    "BEST_COVERAGE": "BEST_COVERAGE",
    "BEST_RECOMMENDED": "BEST_RECOMMENDED",
    "I want it": "I want it",
    "Budget selected": "Budget selected",
    "Offers pending": "Offers pending",
    "We are preparing your offers": "We are preparing your offers",
    "your age need to be over": "your age need to be over",
    "For the license": "For the license",
    "Verification": "Verification",
    "New proposal": "New proposal",
    "Hire insurance": "Hire insurance",
    "Hire Offer": "Hire Offer",
    "Use an actual address": "Use an actual address",
    "Create new address": "Create new address",
    "Bank account (IBAN)": "Bank account (IBAN)",
    "Introduce a value": "Introduce a value",
    "Go back": "Go back",
    "Confirm data": "Confirm data",
    "I prefer to get call by my advisor": "I prefer to get call by my advisor",
    "Initial coverage date": "Initial coverage date",
    "Hire": "Hire",
    "This fill is required. You need to search a real address and select one from the provided list": "This fill is required. You need to search a real address and select one from the provided list",
    "We have received your data and we are going to emit your policy. In 48 hours you will see it in your APP. Thanks for trust in Prudenzia": "We have received your data and we are going to emit your policy. In 48 hours you will see it in your APP. Thanks for trust in Prudenzia",
    "Great! I will contact you as soon as possible and we will resolve your doubts": "Great! I will contact you as soon as possible and we will resolve your doubts",
    "This fill is required. You need select a valid date": "This fill is required. You need select a valid date",
    "This fill is required. You need to check it": "This fill is required. You need to check it",
    "This fill is required. You need to select one option": "This fill is required. You need to select one option",
    "This fill is required. You need select at least one option": "This fill is required. You need select at least one option",
    "This fill is required. You need to insert a number": "This fill is required. You need to insert a number",
    "You need to insert a valid Spanish IBAN": "You need to insert a valid Spanish IBAN",
    "Coverages": "Coverages",
    "See PDF": "See PDF",
    "See detail": "See detail",
    "No coverages": "No coverages",
    "File need to be maximum 5MB": "File need to be maximum 5MB",
    "Max size exceeded": "Max size exceeded",
    "Policy number": "Policy number",
    "Policy Camera": "Policy Camera",
    "Failed to generate policy from camera": "Failed to generate policy from camera",
    "The file could not be opened": "The file could not be opened"
}
